<!-- Seadmed: everything installed at this address, and everything that used to
     be. An address usually has several devices, so they get a page of their own
     rather than a card at the bottom of Info — that card is now a one-line
     summary pointing here.

     This is the only screen that shows archived devices: everywhere else — the
     Info summary, the work order, the act, the customer's view — a replaced
     boiler is gone, which is the point of archiving it. -->
<template>
  <div :class="{ 'obj-card obj-pad': plate }">
    <device-list
      :objectId="objectId"
      :editable="canEdit('object', object) || isTechnic"
      :deletable="canDelete('device', object)"
      show-archived
    />
    <p class="text-caption text-grey mt-2 mb-0">
      Arhiveeritud seade jääb siia alles, aga ei ilmu enam objekti kaardile, töökäsule,
      aktile ega kliendivaatesse. Juba allkirjastatud aktid näitavad seadet edasi.
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import helpersMixin from '@/plugins/helpersMixin'
import DeviceList from '@/components/DeviceList.vue'

export default {
  mixins: [ helpersMixin ],
  components: { DeviceList },
  computed: {
    // A technician may keep the equipment list true — it is his act that asks
    // about it — without being able to edit the address itself. Kustuta stays
    // with the object's own people, exactly as the server has it.
    ...mapGetters(['isTechnic'])
  },
  props: {
    // The object page's new look (Seaded -> Objekt uues kujunduses): the same
    // content in the new card. overview is View.vue's, for the count.
    plate: {
      type: Boolean,
      default: false
    },
    overview: {
      type: Object,
      default: null
    },
    object: {
      required: true
    },
    objectId: {
      required: true
    }
  }
}
</script>
